/**
 * Heart Explosion Effect for Add to Cart Button
 * Creates an exploding splash of heart emojis on hover
 */

class HeartExplosion {
  constructor() {
    this.heartEmojis = ['❤️', '💕', '💖', '💗', '💓', '💝', '💞'];
    this.isAnimating = false;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupWithRetry());
    } else {
      this.setupWithRetry();
    }
  }

  setupWithRetry() {
    // Initial attachment
    this.attachListeners();

    // Shop Pay buttons load asynchronously, so retry after delays
    setTimeout(() => this.attachListeners(), 500);
    setTimeout(() => this.attachListeners(), 1000);
    setTimeout(() => this.attachListeners(), 2000);

    // Also watch for DOM mutations (new buttons being added)
    this._mutationObserver = new MutationObserver(() => {
      this.attachListeners();
    });

    this._mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup on page unload to prevent listener leak
    window.addEventListener(
      'pagehide',
      () => {
        if (this._mutationObserver) {
          this._mutationObserver.disconnect();
          this._mutationObserver = null;
        }
      },
      { once: true }
    );
  }

  attachListeners() {
    // Target the main product page Add to Cart button
    const addToCartButtons = document.querySelectorAll('.product-form__submit, button[name="add"]');

    // Add to Cart buttons
    addToCartButtons.forEach((button) => {
      // Only attach to main product page buttons, not card buttons
      if (!button.closest('.card-wrapper') && !button.closest('.product-card')) {
        if (!button.dataset.heartExplosionAttached) {
          button.addEventListener('mouseenter', (e) => this.createHeartExplosion(e));
          button.addEventListener('focus', (e) => this.createHeartExplosion(e));
          button.dataset.heartExplosionAttached = 'true';
        }
      }
    });

    // Shop Pay buttons - attach to the CONTAINER since iframe buttons can't be accessed
    const shopPayContainers = document.querySelectorAll('.shopify-payment-button');
    shopPayContainers.forEach((container) => {
      if (!container.closest('.card-wrapper') && !container.closest('.product-card')) {
        if (!container.dataset.heartExplosionAttached) {
          container.addEventListener('mouseenter', (_e) => {
            this.createHeartExplosionFromElement(container);
          });
          container.dataset.heartExplosionAttached = 'true';
        }
      }
    });

    // Newsletter Subscribe buttons
    const subscribeButtons = document.querySelectorAll(
      '.newsletter-form__button, button[id*="Newsletter-submit"]'
    );
    subscribeButtons.forEach((button) => {
      if (!button.dataset.heartExplosionAttached) {
        button.addEventListener('mouseenter', (e) => this.createHeartExplosion(e));
        button.addEventListener('focus', (e) => this.createHeartExplosion(e));
        button.dataset.heartExplosionAttached = 'true';
      }
    });
  }

  // Create explosion from an element's center
  createHeartExplosionFromElement(element) {
    const rect = element.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const heartCount = Math.floor(Math.random() * 5) + 8;
    for (let i = 0; i < heartCount; i++) {
      this.createHeart(centerX, centerY, i, heartCount);
    }
  }

  createHeartExplosion(event) {
    // Throttle animations to prevent performance issues
    if (this.isAnimating) return;

    this.isAnimating = true;
    setTimeout(() => {
      this.isAnimating = false;
    }, 300);

    const element = event.currentTarget;
    this.createHeartExplosionFromElement(element);
  }

  createHeart(centerX, centerY, index, total) {
    const heart = document.createElement('div');
    heart.className = 'heart-emoji';

    // Random heart emoji
    heart.textContent = this.heartEmojis[Math.floor(Math.random() * this.heartEmojis.length)];

    // Calculate explosion angle (spread evenly in a circle)
    const angle = (Math.PI * 2 * index) / total + (Math.random() - 0.5) * 0.5;

    // Random distance for more organic feel (60-120px)
    const distance = 60 + Math.random() * 60;

    // Calculate translation values
    const tx = Math.cos(angle) * distance;
    const ty = Math.sin(angle) * distance;

    // Set CSS custom properties for animation
    heart.style.setProperty('--tx', `${tx}px`);
    heart.style.setProperty('--ty', `${ty}px`);

    // Position at button center
    heart.style.left = `${centerX}px`;
    heart.style.top = `${centerY}px`;
    heart.style.transform = 'translate(-50%, -50%)';

    // Add slight random delay for staggered effect
    heart.style.animationDelay = `${Math.random() * 0.1}s`;

    // Append to body
    document.body.appendChild(heart);

    // Remove after animation completes
    setTimeout(() => {
      if (heart.parentNode) {
        heart.remove();
      }
    }, 1400); // Slightly longer than animation duration
  }
}

// Initialize when script loads
new HeartExplosion();
